import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import { format } from 'date-fns';
import DATA_CY from 'constants/data-cy';

export const symbolCustomRender = (text: string) => {
  const symbol = text.toUpperCase();

  return {
    children: (
      <Link href={`/symbol/${symbol}`} passHref>
        <Text
          as="a"
          href={`/symbol/${symbol}`}
          color={color.primary}
          data-cy={`${DATA_CY.CALENDAR.ROW_SYMBOL}-${symbol}`}
        >
          {symbol}
        </Text>
      </Link>
    ),
  };
};

export const dateCustomRender = (text: string, bold = true) => {
  const [year, rawMonth, day] = text.split('-');
  const month = Number(rawMonth) - 1;
  const today = format(new Date(), 'd MMM yy');
  const formattedDate = format(
    new Date(Number(year), Number(month), Number(day)),
    'd MMM yy',
  );

  const isToday = today === formattedDate && bold;

  return {
    children: (
      <Text className={isToday && 'today-column'} color="inherit">
        {formattedDate}
      </Text>
    ),
  };
};
